module.exports = function (fox) {
	'use strict';

	require('script!slick-carousel/slick/slick');
	require('slick-carousel/slick/slick.css');
	require('./stylus/_index.styl');
	require('fox-dynamic-injection!fox-template-loader!./mobile.tpl')(fox);
	require('./widget/mobile.js')(fox);


};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/components/mobile/index.js
// module id = 594
// module chunks = 2